@use "sass:color";
@use "@styles/_variables/colors" as *;
@use "@styles/_variables/breakpoints" as *;

.menu {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-left: auto;
}

@media all and (max-width: $mobile-large) {
  .menu {
    // HUD corner-bracket geometry, shared so the overlay reads as one frame.
    --hud-inset: 2rem; // gap from each viewport corner
    --hud-arm: 2.6rem; // bracket arm length
    --hud-line: 0.15rem; // bracket stroke thickness

    flex-direction: column;
    justify-content: center;
    height: 100vh;
    top: -120%;
    opacity: 1;
    position: fixed;
    left: 0px;
    transition: 0.4s ease-in-out;
    // CRT scanline wash over the dark fill; white lines held under ~3% so the
    // starfield canvas still reads through the blur.
    background:
      repeating-linear-gradient(
        0deg,
        #ffffff06 0 0.1rem,
        transparent 0.1rem 0.5rem
      ),
      color.adjust($black, $alpha: 0.2);
    backdrop-filter: blur(5px);
    padding: 10rem 0;
    width: 100vw;
    z-index: 6;

    // Gold HUD corner brackets, one horizontal + one vertical arm apiece:
    // arm-long var(--hud-arm), arm-thin var(--hud-line). ::before paints
    // top-left (bright) + bottom-right (dimmed); ::after paints bottom-left
    // (dimmed) only — the top-right corner stays clear so the gold close X
    // never collides with a bracket. Decoration only — behind the items
    // (z-index: -1) and never intercepts taps.
    &::before,
    &::after {
      content: "";
      position: absolute;
      inset: var(--hud-inset);
      z-index: -1;
      pointer-events: none;
    }

    // Top-left (bright) + bottom-right (dimmed) corners.
    &::before {
      background:
        linear-gradient($gold, $gold) left top /
          var(--hud-arm) var(--hud-line) no-repeat,
        linear-gradient($gold, $gold) left top /
          var(--hud-line) var(--hud-arm) no-repeat,
        linear-gradient($gold-semi-transparent, $gold-semi-transparent)
          right bottom / var(--hud-arm) var(--hud-line) no-repeat,
        linear-gradient($gold-semi-transparent, $gold-semi-transparent)
          right bottom / var(--hud-line) var(--hud-arm) no-repeat;
    }

    // Bottom-left (dimmed) corner.
    &::after {
      background:
        linear-gradient($gold-semi-transparent, $gold-semi-transparent)
          left bottom / var(--hud-arm) var(--hud-line) no-repeat,
        linear-gradient($gold-semi-transparent, $gold-semi-transparent)
          left bottom / var(--hud-line) var(--hud-arm) no-repeat;
    }

    // Pre-boot hidden state — scoped to the mobile overlay only.
    li {
      opacity: 0;
    }

    &.visible {
      top: 0;

      // Items rise + fade in, staggered ~80ms apart, starting as the 0.4s
      // slide settles so they land with the overlay.
      li {
        animation: menuItemBoot 0.35s ease-out both;
      }
      li:nth-child(1) { animation-delay: 0.15s; }
      li:nth-child(2) { animation-delay: 0.23s; }
      li:nth-child(3) { animation-delay: 0.31s; }
    }
  }

  // Scoped per CSS module file; keyed to the mobile overlay boot.
  @keyframes menuItemBoot {
    from {
      opacity: 0;
      transform: translateY(1.6rem);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
